<template>
  <div class="sales-summary">
    <div class="full-container">
      <div class="top-navbar">
        <div class="row align-items-center">
          <div class="col-md-4">
            <!--                        <div class="top-navbar-left">-->
            <!--                            <select name="test" class="form-control input-dropdown">-->
            <!--                                <option value="123">123</option>-->
            <!--                                <option value="321">321</option>-->
            <!--                                <option value="567">567</option>-->
            <!--                            </select>-->
            <!--                        </div>-->
          </div>

          <div class="col-md-4">
            <div class="top-navbar-center">
              Preset Venue
              <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="top-navbar-right">
              <button
                class="btn btn-ecdc"
                @click="$router.push({ name: 'presetVenueDetails' })"
              >
                Venue Details
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-list row row-cols-7">
        <div :key="data.id" class="col" v-for="data in weekData">
          <div class="summary-blue-card">
            <div class="card-content">
              <h3 class="card-heading">
                {{ data.name }}
                <small>Total Venue</small>
              </h3>

              <div class="figure">
                {{ data.number }}
                <small>Venue</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-card-list row row-cols-xl-3 row-cols-md-2 row-cols-1 mt-4">
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  CHECKED IN AREA
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getPresetVenueByArea"
                  v-model="areaDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Area</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in areaData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="areaData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in areaData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  CHECKED IN VENUE
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getPresetVenueByVenue"
                  v-model="venueDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Venue</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in venueData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="venueData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in venueData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.name }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card data-card">
            <div class="row data-card-header">
              <div class="col-md-6">
                <h3 class="card-heading">
                  CHECKED IN CATEGORIES
                </h3>
              </div>
              <div class="col-md-6 text-md-right">
                <select
                  class="custom-select form-control"
                  @change="getPresetVenueByCategory"
                  v-model="categoryDateDropdown"
                >
                  <option
                    :key="index"
                    v-for="(data, index) in monthlyDateFilter"
                    :value="data.date"
                  >
                    {{ data.text }}
                  </option>
                </select>
              </div>
            </div>

            <h4 class="section-title">Top 10 Category</h4>

            <div class="row">
              <div class="col-xl-6 col-lg-12 col-sm-6">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in categoryData.slice(0, 5)"
                >
                  <dt class="col-1">{{ (index += 1) }}.</dt>
                  <dt class="col-7">{{ data.category }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
              <div class="col-xl-6 col-lg-12 col-sm-6" v-if="categoryData.length > 5">
                <dl
                  :key="data.id"
                  class="row no-gutters"
                  v-for="(data, index) in categoryData.slice(5, 10)"
                >
                  <dt class="col-1">{{ (index += 6) }}.</dt>
                  <dt class="col-7">{{ data.category }}</dt>
                  <dd class="col-4">
                    {{ data.number }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-loader v-show="isLoading"></app-loader>
  </div>
</template>

<style scoped>
.sales-summary .top-navbar .top-navbar-right button:first-child {
  margin-right: 20px;
}
</style>

<script>
import {
  getDashboardDate,
  checkPermission,
  getPresetVenueSummary,
  getPresetVenueByType
} from "../api";
import { getProj } from "../helpers";

import Loader from "./Loader";

export default {
  components: {
    appLoader: Loader
  },
  data() {
    const moment = require("moment");
    const thisMonday = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    return {
      latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
      restrictViewUsers: false,
      weekData: "",
      isLoading: true,
      venueData: "",
      areaData: "",
      categoryData: "",
      projectId: getProj()["projId"],
      venueDateDropdown: thisMonday,
      areaDateDropdown: thisMonday,
      categoryDateDropdown: thisMonday
    };
  },
  async mounted() {
    this.restrictViewUsers = await this.checkPermission("restrict users");
    await this.getDate();
    await this.getPresetVenueSummary();
    await this.getPresetVenueByVenue();
    await this.getPresetVenueByArea();
    await this.getPresetVenueByCategory();
    this.isLoading = false;
  },
  methods: {
    async getDate() {
      try {
        const params = { dateType: "month" };
        const result = await getDashboardDate(params);
        this.monthlyDateFilter = result.data.data.dates;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async checkPermission(permission) {
      try {
        const result = await checkPermission({ permission: permission });
        return result.data.data;
      } catch (err) {
        return false;
      }
    },
    async getPresetVenueSummary() {
      try {
        let result = await getPresetVenueSummary();
        this.weekData = result.data.data.statistics;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getPresetVenueByVenue() {
      try {
        let result = await getPresetVenueByType({
          date: this.venueDateDropdown,
          type: "venue"
        });
        this.venueData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getPresetVenueByArea() {
      try {
        let result = await getPresetVenueByType({
          date: this.areaDateDropdown,
          type: "area"
        });
        this.areaData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    },
    async getPresetVenueByCategory() {
      try {
        let result = await getPresetVenueByType({
          date: this.categoryDateDropdown,
          type: "category"
        });
        this.categoryData = result.data.data.result;
      } catch (err) {
        alert(err.response.data.message);
      }
    }
  }
};
</script>
